import { FlowDefinition } from 'vivaa-api';

import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField.ts';

export const FlowVersionTarget = FlowDefinition.FlowVersionTarget;
export type FlowVersionTarget = FlowDefinition.FlowVersionTarget;

interface UseSharedSubflowBlockFieldsProps {
  fieldNamePrefix: string;
}

export function useSharedSubflowBlockFields(props: UseSharedSubflowBlockFieldsProps) {
  const { fieldNamePrefix } = props;
  const flowIdFieldProps = useSelectedNodeField<string | undefined>(`${fieldNamePrefix}.flowId`);
  const specificVersionFlowDefinitionIdFieldProps = useSelectedNodeField<string | undefined>(
    `${fieldNamePrefix}.flowDefinitionId`
  );
  const versionTargetFieldProps = useSelectedNodeField<FlowVersionTarget>(
    `${fieldNamePrefix}.versionTarget`
  );

  return {
    flowIdFieldProps,
    specificVersionFlowDefinitionIdFieldProps,
    versionTargetFieldProps,
  };
}
